<template>
  <modal
    v-model="show"
    text="Бронировать"
    text-cancel="отмена"
    :show-cancel-btn="showCancelBtn"
    :btn-color-confirm="colorConfirm"
    :btn-confirm-disabled="hasError"

    :style-popup="'max-width: 450px;min-width: 300px;'"

    @close="closeModal"
    @cancel="closeModal"
    @ok="sendBooking"
  >
    <div slot="header">
      <div class="form-block__header">
        <div class="form-block__title">
          <h3>{{localTur.tur_name}}</h3>
        </div>
      </div>
    </div>

    <div slot="content" class="form-block__content">

      <div class="form-block__group-input">
        <div class="form-block__block-input">
          <label for="dateStart" class="form-block__label"><sup class="form-block__required">*</sup>Дата заезда</label>
          <date-pick
            v-model="turDateStart"
            format="DD.MM.YYYY"
            :inputAttributes="{
                      readonly: 'readonly',
                      placeholder: 'Дата заезда',
                      id: 'dateStart',
                      class: 'form-block__input '
                    }"
            :selectable-year-range="3"
            :weekdays="datePicker.lang.weekdays"
            :months="datePicker.lang.months"
          ></date-pick>
        </div>
        <div class="form-block__block-input">
          <label for="dateEnd" class="form-block__label"><sup class="form-block__required">*</sup>Дата выезда</label>
          <date-pick
            v-model="turDateEnd"
            format="DD.MM.YYYY"
            :inputAttributes="{
                      readonly: 'readonly',
                      placeholder: 'Дата выезда',
                      id: 'dateEnd',
                      class: 'form-block__input'
                    }"
            :selectable-year-range="3"
            :weekdays="datePicker.lang.weekdays"
            :months="datePicker.lang.months"
          ></date-pick>
        </div>
      </div>

      <div class="form-block__block-input_row">
        <label class="form-block__label"><sup class="form-block__required">*</sup>Количество взрослых в группе:</label>
        <input-amount
          v-model="turCountAdults"
          :is-required="true"
          @error="isError"
        ></input-amount>
      </div>

      <div class="form-block__block-input_row">
        <label class="form-block__label"><sup class="form-block__required">*</sup>Количество детей в группе:</label>
        <input-amount
          v-model="turCountChildrens"
          :is-required="true"
          @error="isError"
        ></input-amount>
      </div>

      <div class="form-block__block-input_row">
        <label class="form-block__label"><sup class="form-block__required">*</sup>Количество сопровождающих (бесплатно):</label>
        <input-amount
          v-model="turCountEscorts"
          :is-required="true"
          @error="isError"
        ></input-amount>
      </div>

      <div class="form-block__block-input_row">
        <label for="food" class="form-block__label"><sup class="form-block__required">*</sup>Питание:</label>

        <input-text
          v-model="turFood"
          :id="'food'"
          :is-required="true"
          @error="isError"
          :input-style="'width: 320px;'"
        ></input-text>
      </div>

      <h4 style="margin-top: 10px;">Контактные данные</h4>

      <div class="form-block__block-input_row">
        <label for="turUserName" class="form-block__label"><sup class="form-block__required">*</sup>Имя:</label>

        <input-text
          v-model="turUserName"
          :id="'turUserName'"
          :is-required="true"
          @error="isError"
          :input-style="'width: 320px;'"
        ></input-text>
      </div>

      <div class="form-block__block-input_row">
        <label for="turUserEmail" class="form-block__label"><sup class="form-block__required">*</sup>Почта:</label>

        <input-text
          v-model="turUserEmail"
          :id="'turUserEmail'"
          :is-required="true"
          @error="isError"
          :input-style="'width: 320px;'"
        ></input-text>
      </div>

      <div class="form-block__block-input_row">
        <label for="turUserPhone" class="form-block__label"><sup class="form-block__required">*</sup>Телефон:</label>

        <input-text
          v-model="turUserPhone"
          :id="'turUserPhone'"
          :is-required="true"
          @error="isError"
          :input-style="'width: 320px;'"
        ></input-text>
      </div>

      <div class="form-block__block-input" style="margin-top: 10px;">
        <label
          for="turNote"
          class="form-block__label"
        >Примечание:</label>
        <textarea
          v-model="turNote"
          id="turNote"
          class="form-block__textarea"
          style="width: 420px;"
        ></textarea>
      </div>
    </div>
  </modal>
</template>

<script>
	import modal from './../Modal';
	import DatePick from 'vue-date-pick';
	import 'vue-date-pick/dist/vueDatePick.css';
	import inputAmount from './../InputAmount';
	import inputText from './../InputText';

	export default {
		name: "ModalForm",
		components: {
			modal,
			DatePick,
			inputAmount,
			inputText
		},
		props: {
			tur: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				localTur: {},
				show: true,

				turDateStart: '',
				turDateEnd: '',
				turCountAdults: 0,
				turCountChildrens: 0,
				turCountEscorts: 0,
				turFood: '',
				turUserName: '',
				turUserEmail: '',
				turUserPhone: '',
				turNote: '',

				hasError: true,
				errorFields: [
					'turDateStart',
					'turDateEnd',
					'turCountAdults',
					'turCountChildrens',
					'turCountEscorts',
					'turFood',
					'turUserName',
					'turUserEmail',
					'turUserPhone'
				],

				showCancelBtn: true,
				colorConfirm: 'success',

				showManagers: false,

				datePicker: {
					lang: {
						weekdays: ['Пн', 'Вт', 'Ср', 'Чтв', 'Птн', 'Сб', 'Вск'],
						months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
					}
				}
			}
		},
		methods: {
			closeModal() {
				this.localShowModal = false;
				this.$emit('close', this.localShowModal)
			},

			sendBooking() {
				if (!this.hasError) {
					let turFormData = {
						turID: this.tur.id_tur,
						turDuration: this.tur.dlitelnost,
						turName: this.tur.tur_name,
						turDateStart: this.turDateStart,
						turDateEnd: this.turDateEnd,
						turCountAdults: this.turCountAdults,
						turCountChildrens: this.turCountChildrens,
						turCountEscorts: this.turCountEscorts,
						turFood: this.turFood,
						turUserName: this.turUserName,
						turManagers: this.tur.managers_list,
						turUserEmail: this.turUserEmail,
						turUserPhone: this.turUserPhone,
						turNote: this.turNote
					};

					this.$emit('send-booking', turFormData);
				}
			},

			isError(state) {
				let isError = false;

				this.errorFields.forEach(fieldName => {
					if (this.$data[fieldName] === '' || !this.$data[fieldName]) {
						isError = true;
					}
				});

				this.hasError = isError;
			},

			debug() {
				if (this.DEBUG) {
					this.turFood = 'Все';
					this.turUserName = 'Иванов';
					this.turUserEmail = 'example@mail.ru';
					this.turUserPhone = '+7 (978) 000 30 00';
					this.turNote = 'Нет -';
				}
			}
		},
		watch: {
			tur() {
				this.localTur = this.tur;
			},
			turDateStart() {
				this.isError();
			},
			turDateEnd() {
				this.isError();
			}
		},
		beforeUpdate() {
			this.debug();
		},
		mounted() {
			this.localTur = this.tur;
			this.turDateStart = this.tur.turDateStart;
			this.turDateEnd = this.tur.turDateEnd;
		}
	}
</script>

<style>
  .vdpComponent.vdpWithInput > input {
    min-width: 50px;
    height: 16px;
    padding: 6px 12px;
    border: 1px solid #CBCBCB;
    border-radius: 2px;
  }
</style>

<style scoped lang="scss">
  .form-block {
    &__header {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: column nowrap;
    }

    &__content {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-content: center;
      align-items: flex-start;
      width: 100%;
    }

    &__title {
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
      background: white;

      &:before {
        position: absolute;
        top: 7px;
        left: 0;
        width: 100%;
        border-bottom: 1px dashed;
      }

      &-name {
        font-weight: bold;
      }

      &-description {
        color: #333333;
        margin-left: 10px;
      }
    }

    &__group-input {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      width: 100%;
    }

    &__block-input {

      &_column {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        flex-flow: column nowrap;
        width: 100%;
      }

      &_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        flex-flow: row nowrap;
        width: 100%;
      }
    }

    &__label {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-start;
      font-weight: bold;
      font-size: 12px;
      margin-right: 15px;
    }

    &__input {
      min-width: 50px;
      width: 100%;
      height: 16px;
      padding: 6px 12px;
      border: 1px solid #CBCBCB;
      background: #fff;
      border-radius: 2px;
    }

    &__textarea {
      width: 100%;
      padding: 6px 12px;
      border: 1px solid #CBCBCB;
      background: #fff;
      border-radius: 2px;
      resize: none;
    }

    &__required {
      display: inline-block;
      position: relative;
      font-weight: bold;
      font-size: 13px;
      color: #f00;
      margin-right: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/Modal/Form.vue